<template>
  <ChipState
    :label="label"
    :isDense="isDense"
    textColor="#FFF"
    bgColor="#1FB27A"
    class="md:!tw-py-0 md:!tw-px-[.3rem]"
  >
    <template #prefix>
      <CheckIconWhite class="sm:!tw-w-[12px] sm:!tw-h-[12px]" />
    </template>
  </ChipState>
</template>
<script setup>
import ChipState from "@/core/components/common/ChipState";
import CheckIconWhite from "@/core/components/icons/CheckIconWhite.vue";

const props = defineProps({
  label: {
    type: String,
    default: "Accept",
  },
  isDense: Boolean,
});
</script>
<script>
export default {
  name: "AcceptChip",
};
</script>
